<script>
import axios from 'axios'
import ActionTemplates from './ActionTemplates'

export default {

  props: {
    isFiltered: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false
    }
  },

  methods: {
    loadDefaultDataSet() {
      this.isLoading = true
      axios.get('/default_data.json').then((response)=>{
        let json = response.data
        setTimeout(()=>{
          Workflow.storage.replaceAll(json.workflows)
          ActionTemplates.storage.replaceAll(json.action_templates)

          this.isLoading = false
          this.$emit('reload')
        }, 500)
      })
    }
  }

}
</script>

<template>
  <section class="section">
    <div class="content has-text-grey has-text-centered">

      <p>
        <b-icon icon="emoticon-sad" size="is-large">
        </b-icon>
      </p>
      <p>Nothing here.</p>
      <br><br>
      <p v-if="!isFiltered">
        <b-button @click="loadDefaultDataSet" :disabled="isLoading" :loading="isLoading">Load default dataset</b-button>
      </p>

    </div>
  </section>
</template>

<style lang="scss">

</style>